import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { S80Monitors } from '../../../helpers/constants';
import { rangeIn_AC, rangeOut_AC } from '../../../store/actions/executor.actions';
import Row from './common/Row';

interface IRangeInOurAreaProps {
  style?: any;
}

const Container = styled.div`
  display: flex;
  width: 160px;
  flex-direction: column;
`;

const ButtonsContainer = styled(Row)`
  display: flex;
  justify-content: space-between;
`;

const Text = styled.p`
  align-self: center;
`;
const Button = styled.div`
  width: 50px;
  height: 50px;
  border: 1px solid;
  align-items: center;
  display: flex;
  justify-content: center;
  cursor: pointer;
`;

const RangeInOutArea: React.FunctionComponent<IRangeInOurAreaProps> = (
  props
) => {
  const dispatch = useDispatch();
  const displayRangeInOut = useSelector(
    (state: any) => state.executor.s80.showRangeInControl
  );
  const rangeIn = () => {
    dispatch(rangeIn_AC({ monitor: S80Monitors.UPPER }));
  };
  const rangeOut = () => {
    dispatch(rangeOut_AC({ monitor: S80Monitors.UPPER }));
  };

  return (
    <Container {...props}>
      {displayRangeInOut && (
        <>
          <Text>Range In / Out</Text>
          <ButtonsContainer>
            <Button onClick={rangeIn}>IN</Button>
            <Button onClick={rangeOut}>OUT</Button>
          </ButtonsContainer>
        </>
      )}
    </Container>
  );
};

export default RangeInOutArea;
